var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.isShowAppletTip ? _c('div', {
    staticClass: "app-applet-tip"
  }, [_c('div', {
    staticClass: "triangle"
  }), _c('div', {
    staticClass: "tip-text"
  }, [_vm._v("\n    点击右上角\n    "), _c('ycf-svg', {
    staticClass: "icon",
    attrs: {
      "icon-name": "more-applet"
    }
  }), _vm._v("\n    添加到我的小程序\n    "), _c('ycf-svg', {
    staticClass: "icon icon-close",
    attrs: {
      "icon-name": "all_new_close_icon"
    },
    on: {
      "click": _vm.close
    }
  })], 1)]) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };